class ClinicalTriages {
  constructor(note, priority, chiefComplaintId) {
    this.note = note;
    this.priority = priority;
    this.chiefComplaintId = chiefComplaintId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      chiefComplaintAdviceId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',

      clinicalTriageManagmentInformationTableHeaders: [
        { text: 'اولویت', value: 'priority', align: 'center' },
        { text: 'توضیحات', value: 'note', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],

      chiefComplaintId: null,
    };
  },
  methods: {
    onValidate: function () {
      if (!this.chiefComplaintAdvice.note) {
        this.snackText = 'عنوان تریاژ بالینی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaintAdvice.note.replace(/\s/g, '').length) {
        this.snackText = 'عنوان تریاژ بالینی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaintAdvice.priority?.toString()) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      return true;
    },
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن تریاژ بالینی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش تریاژ بالینی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getChiefComplaintAdvice(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.chiefComplaintAdvice = new ClinicalTriages('', null, null);
      this.showAddEditModal = false;
    },
    // change status advice
    changeAdviceStatus: function (type, id) {
      this.chiefComplaintAdviceId = id;
      this.confimType = type === 1 ? 'activate' : 'deactivate';
      this.showConfirmDialogFunction();
    },
    showConfirmDialogFunction: function () {
      switch (this.confimType) {
        case 'add':
          this.addChiefCompaintAdvice();
          break;
        case 'edit':
          this.$refs.confirm.showConfirmDialog = true;
          this.$refs.confirm.title = 'ویرایش تریاژ بالینی';
          this.$refs.confirm.text = 'از ویرایش تریاژ بالینی اطمینان دارید؟';
          break;
        case 'delete':
          this.$refs.confirm.title = 'حذف تریاژ بالینی';
          this.$refs.confirm.text = 'از حذف تریاژ بالینی اطمینان دارید؟';
          this.$refs.confirm.showConfirmDialog = true;
          break;
        case 'activate':
          this.$refs.confirm.title = 'فعال سازی تریاژ بالینی';
          this.$refs.confirm.text = 'از فعال سازی تریاژ بالینی اطمینان دارید؟';
          this.$refs.confirm.showConfirmDialog = true;
          break;
        case 'deactivate':
          this.$refs.confirm.title = 'غیرفعال سازی تریاژ بالینی';
          this.$refs.confirm.text = 'از غیرفعال سازی تریاژ بالینی اطمینان دارید؟';
          this.$refs.confirm.showConfirmDialog = true;
          break;
        default:
          break;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },

    confirmDialogConfirmFunction: function () {
      this.disabelConfirm = true;
      switch (this.confimType) {
        case 'edit':
          this.editChiefComplaintAdvice();
          break;
        case 'delete':
          this.deleteChiefComplaintAdvice(this.chiefComplaintAdviceId);
          break;
        case 'activate':
          this.activateChiefComplaintTechnicianAdvice(this.chiefComplaintAdviceId);
          break;
        case 'deactivate':
          this.deactivateChiefComplaintTechnicianAdvice(this.chiefComplaintAdviceId);
          break;
        default:
          return;
      }
    },
    confirmDialogCancelFunction: function () {
      this.$refs.confirm.showConfirmDialog = false;
      this.disabelConfirm = false;
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.chiefComplaintAdviceId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    backToChiefComplaintPage: function () {
      this.$router.push({ name: 'chiefComplaint' });
    },
  },
  computed: {
    filterdAllClinicalTriages: function () {
      return [...this.allChiefComplaintAdvices]?.filter(({ note }) =>
        note.includes(this.searchTitle),
      );
    },
  },
};
